import React, { Component } from 'react';

const { Button, SingleSelectTable } = (() => {
  const TinperNext = window.TinperNext || {};
  const { Table, Radio, Button, Space } = TinperNext;
  const { singleSelect } = Table || {};
  const SingleSelectTable = singleSelect?.(Table, Radio);
  return Object.assign({}, TinperNext, { SingleSelectTable });
})()

import styles from './index.module.less';

export default class DraftSelect extends Component {
  columns = [
    {
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005F', '序号'), dataIndex: "index", key: "index", width: 80,
      render(_text, _record, index) {
        return index + 1;
      },
    },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80060', '页面编码'), dataIndex: "billNo", key: "billNo", width: 200 },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80062', '草稿名称'), dataIndex: "title", key: "title", width: 200 },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80063', '创建人'), dataIndex: "username", key: "username", width: 200 },
  ]
  
  state = {
    selectedRowKeys: [],
    selectedRows: []
  }
  
  onSelectRowKeysChange = (selectedRowKeys: any[], selectedRows: any[]) => {
    this.setState({ selectedRowKeys, selectedRows })
  }

  render () {
    const { selectedRowKeys, selectedRows } = this.state;
    const { data = [] } = this.props;
    return (<div className={ styles['draft-select'] }>
      {
        SingleSelectTable && <>
          <SingleSelectTable
            columns={ this.columns } 
            data={ data } 
            stripeLine={true} 
            bordered
            scroll={{ y: 400 }}
            rowSelection = {{
              selectedRowKeys,
              onChange: this.onSelectRowKeysChange
            }}
          />
          <div className="btn-group">
            <Button colors="secondary" onClick={ this.props?.onCancel }>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80061', '取消')}</Button>
            <Button 
              disabled={ selectedRows.length <= 0 }
              colors="primary" 
              onClick={() => {
              this.props?.onConfirm?.(selectedRows)
            } }>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80064', '确定')}</Button>
          </div>
        </>
      }
    </div>);
  }
}
